<template>
  <div class="$attrs.class">
    <label class="upper">Credit Policy</label>
    <form-component>
      <form novalidate="novalidate" @submit.prevent="save">
        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="policy"
              v-model="policy"
              name="policy"
              label="Credit Policy for Campus"
              type="text"
            />
          </div>
        </div>
        <button type="submit" class="btn btn-primary btn-wide mt-4">
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';

export default {
  name: 'CreditPolicy',

  components: {
    FormComponent,
    InputTextArea
  },

  inject: ['school'],

  data() {
    return {
      policy: ''
    };
  },

  mounted() {
    this.policy = this.school.triage.creditPolicy;
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) return;

      this.errors.clear();

      try {
        await this.school.updateTriage({
          creditPolicy: this.policy
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'Credit Policy Saved!'
        });
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save Credit Policy. Please try again!',
          error: true
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
label.upper {
  @include label;

  color: $green;
  margin-bottom: 20px;
}
</style>
